<template>
	<v-footer v-bind="$attrs" v-on="$listeners" class="footer" app bottom fixed padless>
		<slot />
	</v-footer>
</template>

<script>
export default {
	name: 'AppFooter',
};
</script>

<style scoped lang="scss">
.footer {
	z-index: $z-index-on-top-of-drawer !important;
}
</style>
